import http from "./http";

export const GetItems = async (params = {}) => {
    let data = { params };
    if (params && params.get_csv) {
        data.responseType = 'blob';
    }
    return await http.get("/item", data);
};

export const AddItem = async data => {
    return await http.post("/item", data);
};

export const UpdateItem = async (id, data) => {
    return await http.put(`/item/${id}`, data);
};

export const DeleteItem = async id => {
    return await http.delete("/item/" + id);
};

export const PublishItem = async (id, force = false) => {
    return await http.patch(`/item/${id}/publish${force ? '?force=true' : ''}`);
};

export const AttachPlanToItem = async (itemId, planId) => {
    return await http.patch(`/item/${itemId}/plan/${planId}`);
};

export const DetachPlanFromItem = async (itemId, planId) => {
    return await http.delete(`/item/${itemId}/plan/${planId}`);
};

export const UploadThumbnail = async (data, item) => {
    return await http.post(`item/${item}/logo`, data);
};

export const UploadBanner = async (data, item) => {
    return await http.post(`item/${item}/banner`, data);
};
